import {getAllCompanies} from '../../services/CompanyServices'

const STANDARD_GST_REGEX = /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}Z[0-9A-Za-z]{1}$/;
// Adaequare sandbox GSTIN: state(2) + PAN(10) + 3-digit suffix, e.g. 33AMBPG7773M014
const ADAEQUARE_SANDBOX_GST_REGEX = /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[0-9]{3}$/;

export function isValidCompanyGstNo(gstNo, environment = 'sandbox') {
  const value = (gstNo || '').trim().toUpperCase();
  if (!value) {
    return false;
  }
  if (STANDARD_GST_REGEX.test(value)) {
    return true;
  }
  if ((environment || 'sandbox').toLowerCase() === 'sandbox' && ADAEQUARE_SANDBOX_GST_REGEX.test(value)) {
    return true;
  }
  return false;
}

export function getGstNoValidationMessage(environment = 'sandbox') {
  if ((environment || 'sandbox').toLowerCase() === 'sandbox') {
    return 'invalid GSTNo (use standard GSTIN or Adaequare sandbox format, e.g. 33AMBPG7773M014)';
  }
  return 'invalid GSTNo';
}

export function checkForDuplicateCompany(companyName,cookies, existingId) {
    
    
    let nameCheck = new Promise((resolve, reject) => {
      getAllCompanies(cookies)
      .then((data) => {

        let isCompanyExists = false;
        data.company_data.forEach(company =>{    //Same Company Name mentioned it denoted already exist.
        
          if(
              company.entity_name.toUpperCase() === companyName.trim().toUpperCase()
              && parseInt(existingId) !== company.id){   
              
              console.log(`Company exists with the name - ${companyName}`) 
              isCompanyExists = true;
            
          }
    });
        resolve(isCompanyExists);
      });  
    });

    return nameCheck;
  }